import React from 'react';
import {Grid} from '@mui/material';
import AutoField, {ActionType} from '../../components/AutoForm/AutoFieldNew';
import {useAutoField} from '../../components/AutoForm/useAutoForm';

export const HeaderInvestmentPhilosophyFields: React.FC<{
  contact: {id: string};
}> = ({contact}) => {
  const contactId = contact.id as string;
  const [understandsPrivateAssetsField] = useAutoField(
    `understandsPrivateAssets.${contactId}`
  );

  return (
    <>
      <Grid item xs={4}>
        <AutoField
          field={{
            id: `giaHasLiquidityNeeds.${contactId}`,
            fullWidth: true,
            disabled: !understandsPrivateAssetsField.value,
            label: 'GIA Liquidity Needs',
            type: ActionType.checkboxToggle,
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <AutoField
          field={{
            id: `pensionHasLiquidityNeeds.${contactId}`,
            fullWidth: true,
            disabled: !understandsPrivateAssetsField.value,
            label: 'Pension Liquidity Needs',
            type: ActionType.checkboxToggle,
          }}
        />
      </Grid>
    </>
  );
};
